module.exports = __webpack_public_path__ + "static/media/8.00c4a864.png";